import {
  FormHelperText,
  Input,
  InputLabel,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useState } from "react";

import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";
import { updateDecimalInputOnState } from "../../utilities/tp-validations";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

function DealerCostAndMarginDetails(props) {
  const [error, setError] = useState("");

  return (
    <TableContainer variant="elevated">
      <Table
        striped
        sx={{ minWidth: 650 }}
        aria-label="simple table"
        size={"small"}
      >
        <Typography component="caption" variant="visuallyHidden">
          Simple Table
        </Typography>
        <TableHead>
          <TableRow>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell align="left">
              {props.texts.JD_DEALER}
            </StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow hover key="machineOrigMDP" id="machineOrigMDP">
            <TableCell>
              <InputLabel>{props.texts.MACHINE_MDP}</InputLabel>
            </TableCell>
            <TableCell align="left">
              <Input
                id="machineOrigMDP"
                placeholder=""
                fullWidth
                type={"text"}
                value={props.bids.machineOrigMDP}
                readOnly={props.actionType.action === "view"}
                onChange={(e) => {
                  updateDecimalInputOnState(
                    e.target.value,
                    8,
                    "machineOrigMDP",
                    "JD",
                    props.setBidsTextValue
                  );
                  props.calculateSpreadAndMargin(props);
                }}
              />
            </TableCell>
          </TableRow>
          <TableRow hover key="extAttachCost" id="extAttachCost">
            <TableCell>
              {" "}
              <InputLabel>
                {props.texts.ATT_SPECS_NOT_INCL_MDP + " " + props.texts.MDP}
              </InputLabel>
            </TableCell>
            <TableCell align="left">
              <Input
                id="extAttachCost"
                placeholder=""
                type={"text"}
                value={props.bids.extAttachCost}
                readOnly={props.actionType.action === "view"}
                onChange={(e) => {
                  updateDecimalInputOnState(
                    e.target.value,
                    8,
                    "extAttachCost",
                    "JD",
                    props.setBidsTextValue
                  );
                  props.calculateSpreadAndMargin(props);
                }}
              />
            </TableCell>
          </TableRow>
          <TableRow hover key="extAttachDesc" id="extAttachDesc">
            <TableCell>
              <InputLabel>{props.texts.DESCRIP_ATT_SPECS}</InputLabel>
            </TableCell>
            <TableCell align="left">
              <Input
                id="extAttachDesc"
                placeholder=""
                type={"text"}
                readOnly={props.actionType.action === "view"}
                value={props.bids.extAttachDesc}
                onChange={(e) =>
                  props.setBidsTextValue("extAttachDesc", e.target.value, "JD")
                }
              />
            </TableCell>
          </TableRow>
          <TableRow hover key="rentalIncome" id="rentalIncome">
            <TableCell>
              {" "}
              <InputLabel>{props.texts.RENTAL_APPLIED}</InputLabel>
            </TableCell>
            <TableCell align="left">
              <Input
                id="rentalIncome"
                placeholder=""
                type={"text"}
                value={props.bids.rentalIncome}
                readOnly={props.actionType.action === "view"}
                onChange={(e) => {
                  updateDecimalInputOnState(
                    e.target.value,
                    8,
                    "rentalIncome",
                    "JD",
                    props.setBidsTextValue
                  );
                  props.calculateSpreadAndMargin(props);
                }}
              />
            </TableCell>
          </TableRow>
          <TableRow hover key="totDiscountApplied" id="totDiscountApplied">
            <TableCell>
              <InputLabel>{props.texts.DEERE_DISC_APP}</InputLabel>
            </TableCell>
            <TableCell align="left">
              <Input
                id="totDiscountApplied"
                placeholder=""
                type={"text"}
                value={props.bids.totDiscountApplied}
                readOnly={props.actionType.action === "view"}
                onChange={(e) => {
                  updateDecimalInputOnState(
                    e.target.value,
                    8,
                    "totDiscountApplied",
                    "JD",
                    props.setBidsTextValue
                  );
                  props.calculateSpreadAndMargin(props);
                }}
              />
            </TableCell>
          </TableRow>
          <TableRow hover key="freightPDICost" id="freightPDICost">
            <TableCell>
              {" "}
              <InputLabel>{props.texts.FREIGHT_PDI}</InputLabel>
            </TableCell>
            <TableCell align="left">
              <Input
                id="freightPDICost"
                placeholder=""
                type={"text"}
                value={props.bids.freightPDICost}
                readOnly={props.actionType.action === "view"}
                onChange={(e) => {
                  updateDecimalInputOnState(
                    e.target.value,
                    8,
                    "freightPDICost",
                    "JD",
                    props.setBidsTextValue
                  );
                  props.calculateSpreadAndMargin(props);
                }}
              />
            </TableCell>
          </TableRow>
          <TableRow hover key="finBuyDownCost" id="finBuyDownCost">
            <TableCell>
              <InputLabel>{props.texts.FIN_BUY_DOWN_COST}</InputLabel>
            </TableCell>
            <TableCell align="left">
              <Input
                id="finBuyDownCost"
                placeholder=""
                type={"text"}
                value={props.bids.finBuyDownCost}
                readOnly={props.actionType.action === "view"}
                onChange={(e) => {
                  updateDecimalInputOnState(
                    e.target.value,
                    8,
                    "finBuyDownCost",
                    "JD",
                    props.setBidsTextValue
                  );
                  props.calculateSpreadAndMargin(props);
                }}
              />
            </TableCell>
          </TableRow>
          <TableRow hover key="addnlDlrCost" id="addnlDlrCost">
            <TableCell>
              <InputLabel>{props.texts.OTHER_ADD_DLR_COST}</InputLabel>{" "}
            </TableCell>
            <TableCell align="left">
              <Input
                type={"text"}
                id="addnlDlrCost"
                placeholder=""
                readOnly={props.actionType.action === "view"}
                value={props.bids.addnlDlrCost}
                onChange={(e) => {
                  updateDecimalInputOnState(
                    e.target.value,
                    8,
                    "addnlDlrCost",
                    "JD",
                    props.setBidsTextValue
                  );
                  props.calculateSpreadAndMargin(props);
                }}
              />
            </TableCell>
          </TableRow>
          <TableRow hover key="dlrMarginPct" id="dlrMarginPct">
            <TableCell>
              <InputLabel>{props.texts.REPORTED_LR_MARGIN} (%)</InputLabel>
            </TableCell>
            <TableCell align="left">
              <Input
                id="dlrMarginPct"
                placeholder=""
                type={"text"}
                value={props.bids.dlrMarginPct}
                readOnly={props.actionType.action === "view"}
                onChange={(e) => {
                  if (e.target.value >= 0 && e.target.value <= 30) {
                    setError("");
                    updateDecimalInputOnState(
                      e.target.value,
                      2,
                      "dlrMarginPct",
                      "JD",
                      props.setBidsTextValue
                    );
                  } else {
                    setError(props.texts.REP_DLRMRG_VALIDA_MSG);
                    return false;
                  }
                }}
              />
              <FormHelperText style={{ color: "red" }}>{error}</FormHelperText>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default DealerCostAndMarginDetails;
